export const ALL_CLASS_TESTS = 'ALL_CLASS_TESTS';

export const allClassTests = (data) => {
	return {
		type: ALL_CLASS_TESTS,
		allClassTestData: data
	}
};
